import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Button } from "antd";
import { FaMapMarkerAlt } from "react-icons/fa";



const BirthdayDetails = (props) => {

const {name, role, date, location } = props;

return (
      <div className="flex justify-between items-start ">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-100 text-gray-700 font-semibold">
              {(name ? name.split(" ").map((n) => n[0]).join("") : "")}
          </div>
          <div>
            <h3 className="font-semibold text-gray-800">{name}</h3>
            <p className="text-xs text-gray-500">{role}</p>
            <div className="flex items-center text-gray-600 text-xs">
              <FaMapMarkerAlt className="mr-1 text-gray-400" />
              {location}
            </div>
          </div>
        </div>

        <div className="flex flex-col items-end">
          <span className="text-sm font-semibold text-purple-600">
            {date}
          </span>
          <Button
            size="small"
            className="mt-1 h-6 border border-purple-300 text-purple-600 hover:bg-purple-50 rounded-full"
          >
            Send Wishes
          </Button>
        </div>
      </div>
  );
};

const mapStateToProps = (state) => ({
	// recordList: state.trainingClass.trainingClassList?.items,
	// pagination: state.trainingClass.trainingClassList?.pagination,
	// filters: state.trainingClass.trainingClassList?.filters,
	// requesting: state.trainingClass.trainingClassList?.requesting,
	// error: state.trainingClass.trainingClassList?.error,
});

const mapDispatchToProps = (dispatch) => ({
	// doSearch: (filters) => dispatch(getTrainingClassList(filters)),
	// doDelete: (id) => dispatch(doTrainingClassDelete(id)),
	// doRecordReset: () => dispatch(doTrainingClassReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(BirthdayDetails);
